import React, { Component } from "react";
import intl from "react-intl-universal";

class Industry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      industries: [
        "Agriculture",
        "Architecture, Construction, Engineering",
        "Entertainment",
        "GIS & Geomatics",
        "Government",
        "Insurance",
        "Mining & Minerals",
        "Real Estate & Development",
        "Roofing & Solar",
        "Oil & Gas",
        "Telecommunications",
        "Utilities"
      ]
    };
  }

  selectedchanged = event => {
    this.props.industryHasChanged(event.target.value);
  };

  render() {
    return (
      <div className="form-group">
        <select
          name="industries"
          onChange={this.props.onChange}
          className="form-control round"
          required
        >
          <option default>{intl.get("Select_Industry")}</option>
          {this.state.industries.map(profession => {
            return (
              <option key={profession} value={profession}>
                {profession}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}

export default Industry;
